import { render } from "./WorkspaceSection.vue?vue&type=template&id=2b8de0c6&scoped=true"
import script from "./WorkspaceSection.vue?vue&type=script&lang=js"
export * from "./WorkspaceSection.vue?vue&type=script&lang=js"

import "./WorkspaceSection.vue?vue&type=style&index=0&id=2b8de0c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8de0c6"]])

export default __exports__